import { disablePageScroll, enableScroll } from '../utils/scroll';

function getYouTubeID(url){
  if (!url) return null;
  url = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  return undefined !== url[2] ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
}

export default () => {
  let initialized = false;
  let player;

  function initPlayer() {
    if (initialized) return;
    initialized = true;

    player = document.createElement('div');
    player.classList.add('player');
    player.innerHTML = '<div class="player__overlay"></div><div class="player__frame"></div><button class="player__close"></button>';

    player.querySelectorAll('.player__close, .player__overlay').forEach((element) => {
      element.addEventListener('click', closePlayer);
    });

    document.body.append(player);
  }

  function playVideo(videoUrl) {
    if (!videoUrl) return;

    player.querySelector('.player__frame').innerHTML = `<video src="${videoUrl}" preload="auto" autoplay controls></video>`;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        player.classList.add('shown');
        disablePageScroll(true);
      });
    });
  }

  function playYouTube(youtubeId) {
    if (!youtubeId) return;

    player.querySelector('.player__frame').innerHTML = `<iframe src="https://www.youtube.com/embed/${youtubeId}?showinfo=1&controls=1&autoplay=1&rel=0" frameborder="0" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture" allowfullscreen></iframe>`;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        player.classList.add('shown');
        disablePageScroll(true);
      });
    });
  }

  function closePlayer(event) {
    event?.preventDefault?.();
    player.classList.remove('shown');
    player.querySelector('.player__frame').innerHTML = '';

    setTimeout(function () {
      enableScroll();
    }, 400);
  }

  document.querySelectorAll('.play-video').forEach((container) => {
    container.addEventListener('click', (event) => {
      event.preventDefault();

      initPlayer();

      const videoUrl = container.getAttribute('data-video');
      const youtubeId = getYouTubeID(container.getAttribute('data-youtube'));

      if (videoUrl) {
        playVideo(videoUrl);
      } else if (youtubeId) {
        playYouTube(youtubeId);
      }
    });
  });
};
